import { INVESTMENT_PROFILE_TYPE_ENTITY } from "@components/Domain";

type Investment = {
  profileType?: string;
};

const isEntityInvestment = ({ profileType }: Investment): boolean => {
  const isEntity = profileType === INVESTMENT_PROFILE_TYPE_ENTITY;

  return isEntity;
};

export default isEntityInvestment;
